import type { FaireProductEntity } from "../../entity_types/product";

export const p_svcf8asuzq: FaireProductEntity = {
  token: "p_svcf8asuzq",
  type: "product",
  name: "CWMM10455_FOOTBALL GAME DAY BEADED ELASTIC BRACELET",
  brandToken: "b_gd86yguu29",
  brandName: "NINEXIS",
  imageUrl:
    "https://cdn.faire.com/fastly/b8025abdce726dfbccc72a3595190cbfa40c7ef160db2c04ec7742f3e5b227a5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9cf5610e0651f79efb6e11c0fe6d2e145dc82a8d17e90203df2016098f9123e2.jpeg",
    "https://cdn.faire.com/fastly/c202babc77bfd61f10ece3797810b9ba0623cc9bad8e21af7480ce57aa0408d3.jpeg",
    "https://cdn.faire.com/fastly/7aeec82f43e57bb4c079fc921a6129f59401e05109d305e5dbfbe7fba0fc4192.jpeg",
    "https://cdn.faire.com/fastly/300a318e9880ea3eef9997cd9688704a638978550fdbc787797bf7ff80c9267e.jpeg",
    "https://cdn.faire.com/fastly/2bd462e7c43aaa3adf31694ff2e3d84c0319d6e6a3a9648f05ee6428f595f870.jpeg",
    "https://cdn.faire.com/fastly/759543bda67d7352491b61bf9f6a1a9f5428d3c5e1c9944701d0a8fc7c3d2435.jpeg",
    "https://cdn.faire.com/fastly/4bcc6758da1ab98fb11bfcd75e4fbf0ef4a21c00ec998a8ee1090d2c1c1ed466.jpeg",
    "https://cdn.faire.com/fastly/a7669b7e31ad88ccc65c05e032532050c35c434e5c077f744c45d88981aae5df.jpeg",
  ],
  priceDollars: 4.16,
  description:
    'FOOTBALL GAME DAY BEADED ELASTIC BRACELET\n100% POLYMER CLAY\nSIZE  ONE SIZE \nELASTIC :DIAMETER: 2.36"(6 CM), PERIMETER: 7.09"(18 CM)\nMADE IN CHINA \n\nBOHEMIAN BEADED BRACELET, STRETCH BEAD BRACELET, BOHEMIAN JEWELRY,HEART BEAD BRACELET, LOVE CHARM BRACELET, ADJUSTABLE BEADED BRACELET,4-PACK BRACELET SET, ELASTIC BRACELET, NATURAL STONE BRACELET , ALLOY BRACELET,STACKABLE BRACELETS FOR WOMEN, BOHO CHIC GIFT SET, FESTIVAL JEWELRY,FRIENDSHIP GIFT SET, SUMMER BOHO STRETCH BRACELETS, MINIMALISTIC HEART BRACELET SET,BRACELET FOR WOMEN, WOMEN\'S BRACELET, WRISTBAND,BEADED BRACELET, STRETCH BRACELET, CRYSTAL BRACELET, CHARM BRACELET,GEMSTONE BRACELET, PEARL BRACELET, GOLD PLATED BRACELET, LEATHER BRACELET,MINIMALIST BRACELET, VINTAGE BRACELET, YOGA BRACELET,STACKING BRACELETS, FRIENDSHIP BRACELET, GIFT FOR HER, EVERYDAY JEWELRY',
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:31.869Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
